import { render } from "./PSeriesCompare.vue?vue&type=template&id=bfb751fe&scoped=true"
import script from "./PSeriesCompare.vue?vue&type=script&lang=js"
export * from "./PSeriesCompare.vue?vue&type=script&lang=js"

import "../assets/styles/p-series-compare.css?vue&type=style&index=0&id=bfb751fe&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb751fe"]])

export default __exports__